import { useEffect, useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDishMenuStore } from '../../../../../../store/use-dish-menu-store';
import { useQrStore } from '../../../../../../store/use-qr-store';
import { useTagStaffStore } from '../../../../../../store/use-tag-staff-store';
import { useTreeStore } from '../../../../../../store/use-tree-store';
import { useIikoStore } from '../../../../../../store/use-iiko-store';
import { IdValue } from '../../../../../../types/props';

export const useQrLinks = () => {
  const { handleUpdateQr, qr } = useQrStore();
  const { fetchTags, tags } = useTagStaffStore();
  const { fetchTreeList, list } = useTreeStore();
  const { fetchMenuList, menuList } = useDishMenuStore();
  const { fetchMenuList: fetchIikoMenuList, list: iikoList } = useIikoStore();
  const { t, getLocale } = useLang();

  const trees = useMemo(() => {
    return list?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];
  }, [list, getLocale]);

  useEffect(() => {
    if (!qr?.place_id) return;
    fetchIikoMenuList({ branch_id: String(qr.place_id) });
  }, [qr?.place_id]);

  useEffect(() => {
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
    fetchTreeList({ since_id: 0, n: 1000, is_by_company: true });

    fetchMenuList({
      since_id: 0,
      n: 1000,
      is_by_company: true,
    });
  }, []);

  const selectedTags = tags?.filter((item) => qr?.tags?.some((tag) => tag.id === item.id)) || [];

  const selectedTree =
    trees.find((tree) => tree.id === String(qr?.tree_id)) ||
    (qr?.tree && {
      id: String(qr.tree.id),
      value: getLocale(qr.tree.name),
    });

  const iikoOptions = useMemo(() => {
    const options: IdValue[] =
      iikoList?.map((item) => ({ id: item.id, value: getLocale(item.name) })) || [];
    const selected = options.filter((item) => qr?.iiko_menu_ids?.includes(item.id));
    return { options, selected };
  }, [iikoList, getLocale, qr?.iiko_menu_ids]);

  const menuOptions = useMemo(() => {
    if (!qr?.place_id) return { options: [], selected: [] };
    const options: IdValue[] =
      menuList
        ?.filter((item) => qr?.place_id === item.place_id)
        ?.map((item) => ({ id: item.id, value: getLocale(item.name) })) || [];
    const selected = options.filter((item) => qr?.menu_ids?.includes(item.id));
    return { options, selected };
  }, [menuList, getLocale, qr?.menu_ids, qr?.place_id]);

  return {
    qr,
    tags,
    trees,
    selectedTags,
    selectedTree,
    handleUpdateQr,
    iikoOptions,
    menuOptions,
    t,
  };
};
